/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

import React from "react";
import useCeleryProgressData from "./useCeleryProgressData";
import { initState } from "./initState";

const CeleryProgressContext = React.createContext(initState);
export const useCeleryProgressContext = () =>
    React.useContext(CeleryProgressContext);

const CeleryProgressSwitchContext = React.createContext(() => {});
export const useCeleryProgressSwitchContext = () =>
    React.useContext(CeleryProgressSwitchContext);

export default ({ children }) => {
    const { value, setValue } = useCeleryProgressData();
    return (
        <CeleryProgressContext.Provider value={value}>
            <CeleryProgressSwitchContext.Provider
                value={(incomingValue) => {
                    console.log("Some: ", incomingValue);
                    if (typeof incomingValue === "function")
                        setValue(incomingValue);
                    else if (typeof incomingValue === "object")
                        setValue((state) => ({ ...state, ...incomingValue }));
                }}
            >
                {children}
            </CeleryProgressSwitchContext.Provider>
        </CeleryProgressContext.Provider>
    );
};
